import { Radio } from 'hljd'
import React from 'react'

const PlaceSelect = ({ value, onChange }) => {
  const list = [
    {
      label: '室内',
      value: 1
    },
    {
      label: '户外',
      value: 2
    }
  ]

  return (
    <>
      <Radio.Group value={Number(value)} onChange={onChange}>
        {list.map(item => (
          <Radio.Button key={item.value} value={item.value}>
            {item.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </>
  )
}

export default PlaceSelect
